const API = ("" || "") + "/api/media";

async function req(path, opts = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
    ...opts,
  });
  if (res.status === 401) {
    const err = new Error("unauthenticated");
    err.status = 401;
    throw err;
  }
  if (!res.ok) {
    let msg = "Erro";
    try { const j = await res.json(); msg = j.detail || j.message || msg; } catch {}
    const err = new Error(msg); err.status = res.status; throw err;
  }
  return res.json();
}

export const mediaApi = {
  login: (email, password) => req("/auth/login", { method: "POST", body: JSON.stringify({ email, password }) }),
  me: () => req("/auth/me"),
  logout: () => req("/auth/logout", { method: "POST" }),
  home: () => req("/home"),
  contentAll: (mediaType) => req(`/content/all${mediaType ? `?mediaType=${mediaType}` : ""}`),
  catalog: (mediaType) => req(`/content/catalog${mediaType ? `?mediaType=${mediaType}` : ""}`),
  teaserAudios: (count = 3) => req(`/teaser-audios?count=${count}`),
  contentItem: (id) => req(`/content/${id}`),
  played: (id) => req("/content/played", { method: "POST", body: JSON.stringify({ ID_ConteudoMediaCenter: id }) }),
  saveProgress: (id, position, duration, completed = false) =>
    req("/content/progress", { method: "POST", body: JSON.stringify({ ID_ConteudoMediaCenter: id, position, duration, completed }) }),
  getProgress: (id) => req(`/content/progress/${id}`),
  continueWatching: () => req("/continue-watching"),
  favorites: () => req("/favorites"),
  favAdd: (id) => req("/favorites/add", { method: "POST", body: JSON.stringify({ ID_ConteudoMediaCenter: id }) }),
  favRemove: (id) => req("/favorites/remove", { method: "POST", body: JSON.stringify({ ID_ConteudoMediaCenter: id }) }),
  history: () => req("/history"),
  playlists: () => req("/playlists"),
  playlistCreate: (name, description = "") => req("/playlists", { method: "POST", body: JSON.stringify({ name, description }) }),
  playlistAddItem: (playlist_id, id) =>
    req("/playlists/add-item", { method: "POST", body: JSON.stringify({ playlist_id, ID_ConteudoMediaCenter: id }) }),
  playlistRemoveItem: (playlist_id, id) =>
    req("/playlists/remove-item", { method: "POST", body: JSON.stringify({ playlist_id, ID_ConteudoMediaCenter: id }) }),
  playlistDelete: (playlist_id) => req(`/playlists/${playlist_id}`, { method: "DELETE" }),
  adminContent: () => req("/admin/content"),
  adminUpdate: (payload) => req("/admin/content/update", { method: "POST", body: JSON.stringify(payload) }),
  // Compra de conteúdo bloqueado — resolve ID_Produto no servidor e adiciona
  // ao carrinho do MyIHTP do mesmo ID_Cliente (sem precisar login MY extra).
  cartAdd: (ID_ConteudoMediaCenter, Quantidade = 1) =>
    req("/cart/add", {
      method: "POST",
      body: JSON.stringify({ ID_ConteudoMediaCenter, Quantidade }),
    }),
};
